import React, { Component } from 'react';
import { Tabs, Tab, Button } from 'react-bootstrap/lib';
import styler from 'react-styling';
import _ from 'lodash';
import { observer } from 'mobx-react';
import radium from 'radium';

import List from './List';
import { uiStateStoreInstance } from '../Stores/UIStateStore';
import getProtectedComponent from '../libs/ProtectedHOC';
import breakpoints from '../../css/breakpoints';

const style = styler `
  Tabs
    position: absolute
    top: 65px
    width: 100%
    @media screen and (max-width: ${breakpoints.MEDIUM_AND_ABOVE}px)
      top: 118px
  LeftTabArea
    position: fixed
    z-index: 100
    &AdminBtn
      left: 405px
      top: 74px
  AdminIcon
    @media screen and (max-width: ${breakpoints.MEDIUM_AND_ABOVE}px)
      display: none
`;

@getProtectedComponent @observer
class ResourcesTabs extends Component {

  props: {
    defaultTab: string,
    handleSelect: Function,
    languagedata: Object,
    mode: string,
    contactList: Array<any>,
    meetingRoomList: Array<any>,
    otherResourcesList: Array<any>,
    letterNew: Function,
    selectedContactEmail: string,
    selectedContact: Object,
    hasMoreContact: boolean,
    hasMoreMeetingRooms: boolean,
    hasMoreOtherResources: boolean,
    loadMore: Function,
    toggleAdminMode: Function,
    handleContactSingleSelection: Function,
    handleContactMultiSelection: Function,
    handleAllSelection: Function,
  }

  render() {
    const isAdmin = uiStateStoreInstance.isAdmin;
    const activeView = uiStateStoreInstance.activeView;
    return (
      <div className="tab-contact" style={style.Tabs}>
        { isAdmin && activeView === 'contact' ?
          <Button
            style={style.LeftTabArea.AdminBtn}
            bsStyle="link"
            onClick={() => this.props.toggleAdminMode()}
          >
            <i className="fa fa-pencil fa-lg" style={style.AdminIcon} />
          </Button>
        : null }
        <Tabs activeKey={this.props.defaultTab} onSelect={this.props.handleSelect}>
          <Tab eventKey={1} title={this.props.languagedata.people}>
            <List
              type="contact"
              mode={this.props.mode}
              listItems={this.props.contactList}
              letterNew={this.props.letterNew}
              selectedContactEmail={this.props.selectedContactEmail}
              selectedContact={this.props.selectedContact}
              toggleItem={(contactEmail, type) => {
                this.props.mode === 'single' ? this.props.handleContactSingleSelection(contactEmail, type) : this.props.handleContactMultiSelection(contactEmail, type);
              }}
              loadMore={_.debounce(() => this.props.loadMore('contacts'), 1000)}
              hasMore={this.props.hasMoreContact}
              handleAllSelection={this.props.handleAllSelection}
            />
          </Tab>
          <Tab eventKey={2} title={this.props.languagedata.meeting_rooms}>
            <List
              type="meetingRoom"
              mode={this.props.mode}
              listItems={this.props.meetingRoomList}
              letterNew={this.props.letterNew}
              selectedContactEmail={this.props.selectedContactEmail}
              selectedContact={this.props.selectedContact}
              toggleItem={(contactEmail, type) => {
                this.props.mode === 'single' ? this.props.handleContactSingleSelection(contactEmail, type) : this.props.handleContactMultiSelection(contactEmail, type);
              }}
              loadMore={_.debounce(() => this.props.loadMore('meetingrooms'), 1000)}
              hasMore={this.props.hasMoreMeetingRooms}
              handleAllSelection={this.props.handleAllSelection}
            />
          </Tab>
          <Tab eventKey={3} title={this.props.languagedata.other_resources}>
            <List
              type="resource"
              mode={this.props.mode}
              listItems={this.props.otherResourcesList}
              letterNew={this.props.letterNew}
              selectedContactEmail={this.props.selectedContactEmail}
              selectedContact={this.props.selectedContact}
              toggleItem={(contactEmail, type) => {
                this.props.mode === 'single' ? this.props.handleContactSingleSelection(contactEmail, type) : this.props.handleContactMultiSelection(contactEmail, type);
              }}
              loadMore={_.debounce(this.props.loadMore, 1000)}
              hasMore={this.props.hasMoreOtherResources}
              handleAllSelection={this.props.handleAllSelection}
            />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default radium(ResourcesTabs);



// WEBPACK FOOTER //
// ./src/js/Components/ResourcesTabs.js